import { VendorCTAReducerTypes } from '../redux/vendorCTAsReducer';

export const getEnabledVendorCTAs = (content: VendorCTAReducerTypes) => {
  const { vendorCtaGroup } = content;

  const enabledCTAs = {
    vendorCtaGroup: vendorCtaGroup?.filter((cta) => cta.isVendorCtaEnabled),
  };

  return enabledCTAs;
};
